import React from 'react'
import Accordion from 'react-bootstrap/Accordion';
import Select from 'react-select';
const Agent = () => {
    const ApplicableOption = [{ value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' },];
    return (
        <div className='card p-3'> <Accordion defaultActiveKey="0" className="accordion-item rounded mb-3">
            <Accordion.Item eventKey="0">
                <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                    {/* <span className="avatar avatar-md rounded text-dark border me-2">
                    <i className="ti ti-user-plus fs-20" />
                </span> */}
                    Air</Accordion.Header>
                <Accordion.Body>
                    <div className="row">
                        <div className="col-6">


                            <div className="mb-3 form-check">
                                <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                <label className="form-label" htmlFor="exampleCheck1">
                                    OverSeas Agent
                                </label>

                            </div>
                        </div>
                        <div className="col-6">


                            <div className="mb-3 form-check">
                                <label className="form-label" htmlFor="exampleCheck1">
                                    Profit Sharing
                                </label>
                                <input type="text" className="form-control form-control-sm " id="exampleCheck1" />


                            </div>
                        </div>


                    </div>
                    <div className="row">
                        <div className="col-6">


                            <div className="mb-3 form-check">
                                <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                <label className="form-label" htmlFor="exampleCheck1">
                                    Local Agent
                                </label>

                            </div>
                        </div>



                    </div>
                    <div className="row">

                        <div className="col-6">


                            <div className="mb-3 form-check">
                                <label className="form-label" htmlFor="exampleCheck1">
                                    Commission
                                </label>
                                <input type="text" className="form-control form-control-sm " id="exampleCheck1" />


                            </div>
                        </div>


                    </div>
                    <div className="row">

                        <div className="col-6">


                            <div className="mb-3 form-check">
                                <label className="form-label" htmlFor="exampleCheck1">
                                    Insentive
                                </label>
                                <input type="text" className="form-control form-control-sm " id="exampleCheck1" />


                            </div>
                        </div>


                    </div>
                </Accordion.Body>
            </Accordion.Item>

        </Accordion>
            <Accordion className="accordion-item rounded mb-3">
                <Accordion.Item eventKey="1">
                    <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                        {/* <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-user-plus fs-20" />
                    </span> */}
                        Borrow AWBs</Accordion.Header>
                    <Accordion.Body>
                        <div className="row">
                            <div className="col-6">


                                <div className="mb-0 form-check">

                                    <label className="form-label" htmlFor="exampleCheck1">
                                        OverSeas Agent
                                    </label>
                                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                </div>
                                <input type="text" className="form-control form-control-sm " id="exampleCheck1" />

                            </div>
                            <div className="col-6">


                                <div className="mb-0 ">
                                    <label className="form-label" htmlFor="exampleCheck1">
                                        Iata Code
                                    </label>
                                    <input type="text" className="form-control form-control-sm " id="exampleCheck1" />


                                </div>
                            </div>
                            <div className="col-6">


                                <div className="mb-3 form-check">
                                    <label className="form-label" htmlFor="exampleCheck1">
                                        Account No
                                    </label>
                                    <input type="text" className="form-control form-control-sm " id="exampleCheck1" />


                                </div>
                            </div>

                        </div>

                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            <Accordion className="accordion-item rounded mb-3">
                <Accordion.Item eventKey="1">
                    <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                        {/* <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-user-plus fs-20" />
                    </span> */}
                        Sea</Accordion.Header>
                    <Accordion.Body>
                        <div className="row">
                            <div className="col-6">


                                <div className="mb-3 form-check">
                                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                    <label className="form-label" htmlFor="exampleCheck1">
                                        OverSeas Agent
                                    </label>

                                </div>
                            </div>
                            <div className="col-6">


                                <div className="mb-3 form-check">
                                    <label className="form-label" htmlFor="exampleCheck1">
                                        Profit Sharing
                                    </label>
                                    <input type="text" className="form-control form-control-sm " id="exampleCheck1" />


                                </div>
                            </div>


                        </div>
                        <div className="row">
                            <div className="col-6">


                                <div className="mb-3 form-check">
                                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                    <label className="form-label" htmlFor="exampleCheck1">
                                        Local Agent
                                    </label>

                                </div>
                            </div>



                        </div>
                        <div className="row">

                            <div className="col-6">


                                <div className="mb-3 form-check">
                                    <label className="form-label" htmlFor="exampleCheck1">
                                        Commission
                                    </label>
                                    <input type="text" className="form-control form-control-sm " id="exampleCheck1" />


                                </div>
                            </div>


                        </div>
                        <div className="row">

                            <div className="col-6">


                                <div className="mb-3 form-check">
                                    <label className="form-label" htmlFor="exampleCheck1">
                                        Insentive
                                    </label>
                                    <input type="text" className="form-control form-control-sm " id="exampleCheck1" />


                                </div>
                            </div>


                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

            <Accordion className="accordion-item rounded mb-3">
                <Accordion.Item eventKey="1">
                    <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                        {/* <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-user-plus fs-20" />
                    </span> */}
                        Shipping Agent</Accordion.Header>
                    <Accordion.Body>
                        <div className="row">
                            <div className="col-4">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                            For Sea
                                        </label>

                                    </div>
                                    <Select

                                        className='custom-selector'
                                        options={ApplicableOption}
                                    // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                    // onBlur={formik.handleBlur}
                                    />
                                    {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                            For Air
                                        </label>

                                    </div>
                                    <Select

                                        className='custom-selector'
                                        options={ApplicableOption}
                                    // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                    // onBlur={formik.handleBlur}
                                    />
                                    {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                            For Land
                                        </label>

                                    </div>
                                    <Select

                                        className='custom-selector'
                                        options={ApplicableOption}
                                    // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                    // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                    // onBlur={formik.handleBlur}
                                    />
                                    {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                </div>
                            </div>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>


            <Accordion className="accordion-item rounded mb-3">
                <Accordion.Item eventKey="1">
                    <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                        {/* <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-user-plus fs-20" />
                    </span> */}
                        Land</Accordion.Header>
                    <Accordion.Body>
                        <div className="row">
                            <div className="col-6">


                                <div className="mb-3 form-check">
                                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                    <label className="form-label" htmlFor="exampleCheck1">
                                        OverSeas Agent
                                    </label>

                                </div>
                            </div>
                            <div className="col-6">


                                <div className="mb-3 form-check">
                                    <label className="form-label" htmlFor="exampleCheck1">
                                        Profit Sharing
                                    </label>
                                    <input type="text" className="form-control form-control-sm " id="exampleCheck1" />


                                </div>
                            </div>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

            <Accordion className="accordion-item rounded mb-3">
                <Accordion.Item eventKey="1">
                    <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                        {/* <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-user-plus fs-20" />
                    </span> */}
                        Co Load</Accordion.Header>
                    <Accordion.Body>
                        <div className="row">
                            <div className="col-12">
                                <div className="mb-3 form-check">
                                    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                    <label className="form-label" htmlFor="exampleCheck1">
                                        Co-Load Agent
                                    </label>
                                </div>

                            </div>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            <Accordion className="accordion-item rounded mb-3">
                <Accordion.Item eventKey="1">
                    <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark">
                        {/* <span className="avatar avatar-md rounded text-dark border me-2">
                        <i className="ti ti-user-plus fs-20" />
                    </span> */}
                        Currency uplift</Accordion.Header>
                    <Accordion.Body>
                        <div className="row">

                            <div className="col-6">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                            For Air
                                        </label>

                                    </div>
                                    <div className="row">
                                        <div className="col-8">

                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="name"
                                                name="name"
                                                placeholder='Enter For Air'
                                            // onChange={formik.handleChange}
                                            // onBlur={formik.handleBlur}
                                            // value={formik.values.name}
                                            />
                                        </div>
                                        <div className="col-4">

                                            <Select

                                                className='custom-selector'
                                                options={ApplicableOption}
                                            // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                            // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                            // onBlur={formik.handleBlur}
                                            />
                                        </div>
                                    </div>
                                    {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                            For Land
                                        </label>

                                    </div>
                                    <div className="row">
                                        <div className="col-8">

                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="name"
                                                name="name"
                                                placeholder='Enter For Air'
                                            // onChange={formik.handleChange}
                                            // onBlur={formik.handleBlur}
                                            // value={formik.values.name}
                                            />
                                        </div>
                                        <div className="col-4">

                                            <Select
                                                className='custom-selector'
                                                options={ApplicableOption}
                                            // value={ApplicableOption.find(option => option.value === formik.values.D_Format) || null} // Control the value based on Formik's state
                                            // onChange={(selectedOption) => formik.setFieldValue("D_Format", selectedOption.value)} // Set the correct field in Formik
                                            // onBlur={formik.handleBlur}
                                            />
                                        </div>
                                    </div>
                                    {/* {formik.touched.name && formik.errors.name ? (
                    <div className="error">{formik.errors.name}</div>
                ) : null} */}
                                </div>
                            </div>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

            <hr />
            <div className="row justify-content-end mt-3 gap-2">
                <button className="btn btn-primary text-xs w-fit" type="submit" >
                    Save
                </button>
                <button className="btn btn-primary text-xs w-fit" type="submit" >
                    Save & Close
                </button>
                <button className="btn btn-primary text-xs w-fit" type="submit" >
                    Save & New
                </button>
                <button className="btn btn-primary text-xs w-fit" type="submit" >
                    Close
                </button>

            </div>
        </div>
    )
}

export default Agent